import { isString } from 'lodash';

function format(value: number = 0, singular: string, plural: string) {
  if (value === 1) {
    return `${value} ${singular}`;
  }

  return `${value} ${plural}`;
}

export default function formatDuration(durationInYears: number | string | undefined) {
  if (!durationInYears) {
    return;
  }

  if (isString(durationInYears)) {
    durationInYears = parseFloat(durationInYears);
  }

  const years = Math.floor(durationInYears);
  const months = Math.round((durationInYears - years) * 12);
  const formatted = `${format(years, 'yr', 'yrs')} ${format(months, 'mth', 'mths')}`;

  return formatted;
}
